module.exports = {
	"/": [
		"jp"
	],
	"/breached-passwords/": [
		"jp"
	],
	"/guardian/": [
		"jp"
	],
	"/multifactor-authentication/": [
		"jp"
	],
	"/how-it-works/": [
		"jp"
	],
	"/learn/build-or-buy-20-identity-management-questions/": [
		"jp"
	],
	"/learn/harvard-medical-school-identity-secures-nih-research/": [
		"jp"
	],
	"/learn/jetprivilege-case-study/": [
		"jp"
	],
	"/learn/marks-spencer-auth0-authentication-scalability-in-action/": [
		"jp"
	],
	"/learn/safari-case-study/": [
		"jp"
	],
	"/learn/schneider-electric-case-study/": [
		"jp"
	],
	"/signup/": [
		"jp"
	],
	"/why-auth0": [
		"jp"
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/modules/locale-redirection/config.json
// module id = 1095
// module chunks = 0